import {FaFootballBall} from 'react-icons/fa';



function Footer() {
  return (
    <div className="mx-auto mt-4 bg-gray-700 w-full text-center p-10 content-center">
      <FaFootballBall className='inline text-6xl'/>
      <p className='pt-4'>Copyright &copy; 2023 All rights reserved</p>
    </div>
  )
}

export default Footer
